/**
 * Image registry — typed URL lookups for static assets served from public/. These are URL
 * strings (used via <img src> or CSS url()), NOT React components (icons are the component
 * half, in icons.ts). Seeded with only the real brand assets that exist in public/.
 */
export const images = {
  "logo-primary": "/images/logo/primary-logo.svg", // full wordmark, color
  "logo-mono": "/images/logo/secondary-logo.svg", // full wordmark, monochrome
  "mark-primary": "/images/icons/primary-icon.svg", // mark only, terracotta
  "mark-inverse": "/images/icons/secondary-icon.svg", // mark only, white/inverse
  // Espace candidat status banner (E4, Figma `479:26281`) — the SAME two 3D renders the
  // component's own note says are "cloned from the archive, not redrawn", downscaled from the
  // Figma export's 2390x1792 source to 300x225 for the ~90px display size.
  "illustration-deadline-warning": "/images/illustrations/deadline-warning.png",
  "illustration-submitted-check": "/images/illustrations/submitted-check.png",
} satisfies Record<string, string>;

export type ImageKey = keyof typeof images;
